/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetRiskPolicyApprovalSecurityOption1 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type GetRiskPolicyApprovalSecurityOption2 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type GetRiskPolicyApprovalSecurity = {
  option1?: GetRiskPolicyApprovalSecurityOption1 | undefined;
  option2?: GetRiskPolicyApprovalSecurityOption2 | undefined;
};

export type GetRiskPolicyApprovalRequest = {
  /**
   * The approval request ID.
   */
  id: string;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type GetRiskPolicyApprovalSecurityOption1$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const GetRiskPolicyApprovalSecurityOption1$outboundSchema: z.ZodMiniType<
  GetRiskPolicyApprovalSecurityOption1$Outbound,
  GetRiskPolicyApprovalSecurityOption1
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function getRiskPolicyApprovalSecurityOption1ToJSON(
  getRiskPolicyApprovalSecurityOption1: GetRiskPolicyApprovalSecurityOption1,
): string {
  return JSON.stringify(
    GetRiskPolicyApprovalSecurityOption1$outboundSchema.parse(
      getRiskPolicyApprovalSecurityOption1,
    ),
  );
}

/** @internal */
export type GetRiskPolicyApprovalSecurityOption2$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const GetRiskPolicyApprovalSecurityOption2$outboundSchema: z.ZodMiniType<
  GetRiskPolicyApprovalSecurityOption2$Outbound,
  GetRiskPolicyApprovalSecurityOption2
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function getRiskPolicyApprovalSecurityOption2ToJSON(
  getRiskPolicyApprovalSecurityOption2: GetRiskPolicyApprovalSecurityOption2,
): string {
  return JSON.stringify(
    GetRiskPolicyApprovalSecurityOption2$outboundSchema.parse(
      getRiskPolicyApprovalSecurityOption2,
    ),
  );
}

/** @internal */
export type GetRiskPolicyApprovalSecurity$Outbound = {
  Option1?: GetRiskPolicyApprovalSecurityOption1$Outbound | undefined;
  Option2?: GetRiskPolicyApprovalSecurityOption2$Outbound | undefined;
};

/** @internal */
export const GetRiskPolicyApprovalSecurity$outboundSchema: z.ZodMiniType<
  GetRiskPolicyApprovalSecurity$Outbound,
  GetRiskPolicyApprovalSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => GetRiskPolicyApprovalSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => GetRiskPolicyApprovalSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function getRiskPolicyApprovalSecurityToJSON(
  getRiskPolicyApprovalSecurity: GetRiskPolicyApprovalSecurity,
): string {
  return JSON.stringify(
    GetRiskPolicyApprovalSecurity$outboundSchema.parse(
      getRiskPolicyApprovalSecurity,
    ),
  );
}

/** @internal */
export type GetRiskPolicyApprovalRequest$Outbound = {
  id: string;
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const GetRiskPolicyApprovalRequest$outboundSchema: z.ZodMiniType<
  GetRiskPolicyApprovalRequest$Outbound,
  GetRiskPolicyApprovalRequest
> = z.pipe(
  z.object({
    id: z.string(),
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
    });
  }),
);

export function getRiskPolicyApprovalRequestToJSON(
  getRiskPolicyApprovalRequest: GetRiskPolicyApprovalRequest,
): string {
  return JSON.stringify(
    GetRiskPolicyApprovalRequest$outboundSchema.parse(
      getRiskPolicyApprovalRequest,
    ),
  );
}
